import localesMessages from "./messages.json";

export const messages = {
  en: localesMessages.en,
  fr: localesMessages.fr,
};
